<header>
        <app-default-header></app-default-header>
</header>
<main>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</main>
<footer>
    <div class="container">   
        <app-footer>

        </app-footer>
    </div>
</footer>